<div [@slideInOut]="expanded ? 'open' : 'closed'" class="expander-outer">
  <div *ngIf="expanded" class="expander-panel">
    <div class="expander-columns">
      <div
        class="expander-col expander-col--task"
        *ngIf="
          task.task.taskTypeName || task.task.moDelPin || task.task.releaseCode || task.task.vehicle
        "
      >
        <div class="col-heading">Task {{ taskNumber }}</div>
        <div class="col-row" *ngIf="task.task.taskTypeName">
          <span class="col-label">Type</span>
          <span class="col-value">{{ task.task.taskTypeName }}</span>
        </div>
        <div class="col-row" *ngIf="task.task.vehicle?.make || task.task.vehicle?.model">
          <span class="col-label">Vehicle</span>
          <span class="col-value">{{ task.task.vehicle.make }} {{ task.task.vehicle.model }}</span>
        </div>
        <div class="col-row" *ngIf="task.task.vehicle?.color">
          <span class="col-label">Colour</span>
          <span class="col-value">{{ task.task.vehicle.color }}</span>
        </div>
        <div class="col-row" *ngIf="task.task.moDelPin">
          <span class="col-label">MoDel Pin</span>
          <span class="col-value mono">{{ task.task.moDelPin }}</span>
        </div>
        <div class="col-row" *ngIf="task.task.releaseCode">
          <span class="col-label">Release</span>
          <span class="col-value mono">{{ task.task.releaseCode }}</span>
        </div>
      </div>

      <!-- Pickup -->
      <div class="expander-col" *ngIf="task.task.pickupEarliestDateTime">
        <div class="col-heading"><i class="fa fa-arrow-up" aria-hidden="true"></i> Pickup</div>
        <div class="col-row col-row--window">
          <span class="col-label">Customer</span>
          <span class="col-window">
            <span>{{ task.task.pickupEarliestDateTime | date : 'HH:mm' }}</span>
            <span>{{ task.task.pickupEarliestDateTime | date : 'EEE, d MMM' }}</span>
            <span>{{ task.task.pickupLatestDateTime | date : 'HH:mm' }}</span>
            <span>{{ task.task.pickupLatestDateTime | date : 'EEE, d MMM' }}</span>
          </span>
        </div>
        <route-itinerary-site-hours
          [hours]="task.task.pickupSiteOpeningHours"
          [scheduledDate]="task.pickupEarliestTime"
        ></route-itinerary-site-hours>
      </div>

      <!-- Dropoff -->
      <div class="expander-col" *ngIf="task.task.dropoffEarliestDateTime">
        <div class="col-heading"><i class="fa fa-arrow-down" aria-hidden="true"></i> Drop-off</div>
        <div class="col-row col-row--window">
          <span class="col-label">Customer</span>
          <span class="col-window">
            <span>{{ task.task.dropoffEarliestDateTime | date : 'HH:mm' }}</span>
            <span>{{ task.task.dropoffEarliestDateTime | date : 'EEE, d MMM' }}</span>
            <span>{{ task.task.dropoffLatestDateTime | date : 'HH:mm' }}</span>
            <span>{{ task.task.dropoffLatestDateTime | date : 'EEE, d MMM' }}</span>
          </span>
        </div>
        <route-itinerary-site-hours
          [hours]="task.task.dropoffSiteOpeningHours"
          [scheduledDate]="task.dropoffEarliestTime"
        ></route-itinerary-site-hours>
      </div>
    </div>
    <p class="expander-note">
      <i class="fa fa-info-circle mr-2" aria-hidden="true"></i>
      Please use the timings shown on the itinerary above. The customer windows and site hours here
      are for information and emergency reference only.
    </p>
  </div>
</div>
